<template>
    <div>
        <section>
            <div class="container">
                <div class="row justify-center">
                    <div class="col-xs-12 col-md-7">
                        <div class="text-title">Create New Account</div>
                        <p>You will need to create an account in order to purchase or activate software products using this website.</p>

                        <create-account :returnUrl="returnUrl" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import createAccount from '@/components/CreateAccount'
    export default {
        name: 'new-account',
        components: {
            createAccount,
        },
        props: {
            returnUrl: {
                default: '',
                type: String
            },
        },
    }
</script>
